import { createTrackingUtils } from "..";

const utils = createTrackingUtils({
  name: "flights_web_genius_fares_rank_boost",
  stages: {
    clicked_on_airline_funded_offer: 9
  },
  defaultStage: 1,
  goals: {}
});

export default utils;
